import * as React from "react";
const SvgSimpleFiligreeSaveSelection = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-b49823a2-6d62-4c2c-966d-c294222e2895", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 74.55 74.55", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "73.55 73.55 1 73.55 1 1 64.89 1 73.55 9.08 73.55 73.55", style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("path", { d: "M18.93,1H55.62V24.71c0,2.14-1.74,3.88-3.88,3.88H22.81c-2.14,0-3.88-1.74-3.88-3.88V1h0Z", style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("rect", { x: 43.4, y: 7.36, width: 6.14, height: 14.87, rx: 0.12, ry: 0.12, style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("rect", { x: 12.32, y: 38.78, width: 49.91, height: 24.28, style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("line", { x1: 22.49, y1: 45.94, x2: 52.07, y2: 45.94, style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("line", { x1: 22.49, y1: 51.38, x2: 52.07, y2: 51.38, style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("line", { x1: 22.49, y1: 56.82, x2: 52.07, y2: 56.82, style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }));
export default SvgSimpleFiligreeSaveSelection;
